var map = {
	"./bandlecity_splash.jpg": 3980,
	"./bilgewater_splash.jpg": 3837,
	"./demacia_splash.jpeg": 8798,
	"./demacia_splash.jpg": 7930,
	"./freljord_splash.jpg": 833,
	"./ionia_splash.jpg": 8306,
	"./ixtal_splash.jpg": 8394,
	"./noxus_splash.jpg": 1363,
	"./piltover_splash.jpg": 2410,
	"./runeterra_splash.jpg": 1239,
	"./runeterra_splash.png": 5601,
	"./shadowisles_splash.jpg": 4779,
	"./shurima_splash.jpg": 3635,
	"./targon_splash.jpg": 972,
	"./thevoid_splash.jpg": 8192,
	"./zaun_splash.jpeg": 7750,
	"./zaun_splash.jpg": 6426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9284;